import React from "react";
import PropTypes from "prop-types";

/**
 * @param {Input.propTypes} props
 */
export const Input = (props) => {
	return (
		<input
			min={0}
			required={true}
			type={props.type}
			disabled={props.isDisabled}
			className={[
				"bg-transparent border border-solid rounded-sm focus:outline-none focus:shadow-none px-3 py-1",
				"focus:border-" + props.color,
				"placeholder-" + props.color,
				"border-" + props.color,
				props.className,
			].join(" ")}
			placeholder={props.placeholder}
			onChange={(event) => props.onChange(event.target.value)}
			value={props.value}
		/>
	);
};

Input.defaultProps = {
	isDisabled: false,
	className: "",
	placeholder: "",
	type: "text",
	color: "border-black",
};

Input.propTypes = {
	isDisabled: PropTypes.bool,
	className: PropTypes.string,
	placeholder: PropTypes.string,
	type: PropTypes.string,
	value: PropTypes.any,
	onChange: PropTypes.func,
	/**
	 * Input border color class.
	 * Available options: plugin-1, plugin-2, plugin-3
	 */
	color: PropTypes.string,
};
